// extracted by mini-css-extract-plugin
export default {"doughnutChart":"DoughnutChart_doughnutChart__HtYRi"};